import React, { Component } from "react";
import config from "@config";
import apiEndpoints from "@store/apiEndpoints";
import errorFunctions from "@store/errorFunctions";
import LoadingPage from "@components/Loading/Loading";
import Tabs from "@components/Tabs/Tabs";
import "./CustomerDetail.css";
import Tickets from "./Tickets/Tickets";
import Activities from "./Activities/Activities";
import Devices from "./Devices/Devices";
import Notes from "./Notes/Notes";
import moment from "moment";
import Modal from "react-modal";
import CustomerEdit from "./CustomerEdit/CustomerEdit";
import Logs from "./Logs/Logs";
import ConvertCommercialStaff from "./ConvertCommercialStaff/ConvertCommercialStaff";
import utilityFunctions from "@store/utilityFunctions";
import ErrorPage from "@pages/ErrorPage/ErrorPage";

export default class CustomerDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      customerId: "",
      customer: undefined,
      searchFilter: "",
      warranties: undefined,
      tickets: [],
      ticketActivities: [],
      customerDevices: [],
      customerNotes: [],
      defaultTab: this.props.location.search.includes("devices")
        ? "Device"
        : "Activity",
      showConvertToCommercial: false,
      storeLocation: [],
    };
  }
  componentDidMount() {
    const customerId = this.props.computedMatch.params.id;
    this.setState({ customerId });
    this.retrieveCustomer(customerId);
    this.retrieveCustomerDevices(customerId);
  }

  retrieveCustomer = (id) => {
    this.setState({ loading: true });
    this.props
      .protectedFetch(
        apiEndpoints.customer.detail(id),
        "GET",
        null,
        errorFunctions.checkResponseThenJson,
      )
      .then((res) => {
        this.setState({ loading: false, customer: res });
        // this.retrieveWarranties(this.props.selectedbrandID);
        // this.retrieveCustomerDevices(id);
        // this.retrieveCustomerNotes(id);
      })
      .catch(() => {
        console.log("fail");
        this.setState({ loading: false });
      });
  };

  retrieveCustomerDevices = (id) => {
    this.setState({ loading: true });
    this.props
      .protectedFetch(
        apiEndpoints.customer.devices(id),
        "GET",
        null,
        errorFunctions.checkResponseThenJson,
      )
      .then((res) => {
        const ticketTemp = res?.map((x) => x.tickets).flat();
        const ticketActivitiesTemp = ticketTemp
          .map((ticket) =>
            ticket.ticket_activities.map((item) => {
              return {
                activity: item,
                ticketNumber: ticket.ticket_number,
                ticketId: ticket.id,
              };
            }),
          )
          .flat();

        this.setState({
          loading: false,
          customerDevices: res,
          tickets: ticketTemp,
          ticketActivities: ticketActivitiesTemp,
          defaultTab: "Device",
        });
        // this.retrieveCustomer(id);
        // console.log(res);
      })
      .catch((e) => {
        console.log(e);
        this.setState({ loading: false });
      });
  };

  retrieveTicketDetails = (id) => {
    this.props
      .protectedFetch(
        apiEndpoints.ticket.detail(id),
        "GET",
        null,
        errorFunctions.checkResponseThenJson,
      )
      .then((res) => {
        const ticketDetailTemp = [...this.state.ticketDetails, res];
        this.setState({ loading: false, ticketDetails: ticketDetailTemp });
      })
      .catch(() => {
        console.log("fail");
        this.setState({ loading: false });
      });
  };

  handleRefresh = () => {
    this.retrieveCustomer(this.state.customer.id);
    this.retrieveCustomerDevices(this.state.customer.id);
    this.setState({ defaultTab: "Device" });
  };

  handleConvertToCommercialStaff = (obj) => {
    let url = apiEndpoints.customer.convertToCommercial();

    this.setState({ loading: true });

    const brandId =
      this.state.customerDevices[0]?.device?.brand?.id ||
      this.props.selectedbrandID ||
      utilityFunctions.getCookie("brandId") ||
      this.props.userInfo?.user?.brands?.find(
        (b) => b.country === config.country,
      )?.id ||
      0;

    const payload = {
      customer_id: this.state.customer.id,
      store_location_id: obj.store_location.value,
      brand_id: brandId,
    };

    this.props
      .protectedFetch(
        url,
        "POST",
        payload,
        errorFunctions.checkResponseThenJson,
      )
      .then((response) => {
        this.setState({ loading: false });
        console.log("response", response);
        if (response.employee_id) {
          alert("convert customer to commercial staff successfully");
          window.location.href = "/customer-list";
        } else if (response.status === 409) {
          alert(`cannot convert customer to commercial staff`);
        } else {
          alert("Problem with system. Please refresh and try again later.");
        }
      })
      .catch((err) => {
        this.setState({ loading: false });
        console.log("fail", err);
      });
  };

  render() {
    if (this.state.loading) return <LoadingPage />;
    if (!this.state.customer) {
      return <ErrorPage statusCode={404} />;
    }

    return (
      <div className={"page"}>
        <div className="row">
          <div className="col-md-4 border-start">
            <div className={"pageHeader"}>
              <div className="card mb-3">
                <div className="card-body bg-light">
                  <h2>
                    {[
                      this.state.customer.first_name,
                      this.state.customer.last_name,
                    ]
                      .filter(Boolean)
                      .join(" ") || "Unnamed Customer"}
                  </h2>
                  <h6>{this.state.customer.email}</h6>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header">
                <div className="row">
                  <h6 className="col-9 my-auto">Customer Details</h6>
                  <button
                    className="k-btn k-btn-primary k-btn-sm col-2 m-auto text"
                    onClick={() => this.setState({ showEditCustomer: true })}
                  >
                    Edit
                  </button>{" "}
                </div>
              </div>

              <div className="card-body">
                <div className={"customer-details-item"}>
                  <span className={"customer-details-label"}>First Name: </span>
                  <span>{this.state.customer.first_name}</span>
                </div>
                <div className={"customer-details-item"}>
                  <span className={"customer-details-label"}>Last Name: </span>
                  <span>{this.state.customer.last_name}</span>
                </div>

                <div className={"customer-details-item"}>
                  <span className={"customer-details-label"}>Mobile: </span>
                  <span>{this.state.customer.mobile}</span>
                </div>
                <div className={"customer-details-item"}>
                  <span className={"customer-details-label"}>Email: </span>
                  <span>{this.state.customer.email}</span>
                </div>
                <div className={"customer-details-item"}>
                  <span className={"customer-details-label"}>
                    Last Contacted:{" "}
                  </span>
                  <span>
                    {this.state.tickets &&
                      this.state.tickets.length > 0 &&
                      moment(this.state.tickets[0].last_activity_date).format(
                        "DD/MM/YYYY",
                      )}
                  </span>
                </div>
                <div className={"customer-details-item"}>
                  <span className={"customer-details-label"}>
                    Address Line 1:{" "}
                  </span>
                  <span>{this.state.customer.address_line_one}</span>
                </div>
                <div className={"customer-details-item"}>
                  <span className={"customer-details-label"}>
                    Address Line 2:{" "}
                  </span>

                  <span>{this.state.customer.address_line_two}</span>
                </div>
                <div className={"customer-details-item"}>
                  <span className={"customer-details-label"}>Suburb: </span>
                  <span>{this.state.customer.suburb}</span>
                </div>
                <div className={"customer-details-item"}>
                  <span className={"customer-details-label"}>State: </span>
                  <span>{this.state.customer.state}</span>
                </div>
                <div className={"customer-details-item"}>
                  <span className={"customer-details-label"}>Country: </span>
                  <span>{this.state.customer.country}</span>
                </div>
                <div className={"customer-details-item"}>
                  <span className={"customer-details-label"}>Postcode: </span>
                  <span>{this.state.customer.postcode}</span>
                </div>
                <div className={"customer-details-item"}>
                  <span className={"customer-details-label"}>
                    Store Location:{" "}
                  </span>
                  <span>{this.state.customer.store_location || ""}</span>
                </div>
              </div>
            </div>

            {["Admin", "Staff"].includes(this.props.userInfo?.user?.role) &&
              !this.state.customer.is_staff && (
                <div className="card-body">
                  <button
                    className={"btn btn-outline-primary btn-md mt-4"}
                    onClick={() =>
                      this.setState({ showConvertToCommercial: true })
                    }
                  >
                    Convert To Commercial Staff
                  </button>
                </div>
              )}
          </div>
          <div className="col-md-8">
            <div>
              <Tabs
                resetTab={() => this.setState({ defaultTab: undefined })}
                defaultTab={this.state.defaultTab}
              >
                <div label="Activity">
                  {this.state.ticketActivities &&
                    this.state.ticketActivities.length > 0 && (
                      <Activities
                        data={this.state.ticketActivities}
                        protectedFetch={this.props.protectedFetch}
                        selectedbrandID={this.props.selectedbrandID}
                        role={this.userRole}
                      />
                    )}
                </div>
                <div label="Notes">
                  <Notes
                    protectedFetch={this.props.protectedFetch}
                    selectedbrandID={this.props.selectedbrandID}
                    customerId={this.state.customerId}
                  />
                </div>
                <div label="Device">
                  <Devices
                    customerId={this.state.customerId}
                    data={this.state.customerDevices}
                    protectedFetch={this.props.protectedFetch}
                    selectedbrandID={this.props.selectedbrandID}
                    role={this.userRole}
                    refreshTickets={() =>
                      this.retrieveWarranties(this.props.selectedbrandID)
                    }
                    loading={this.state.loading}
                    handleRefresh={() =>
                      this.handleRefresh(this.state.customerId)
                    }
                    retrieveCustomerDevices={() =>
                      this.retrieveCustomerDevices(this.state.customer.id)
                    }
                  />
                </div>
                <div label="Tickets">
                  <Tickets
                    data={this.state.tickets}
                    protectedFetch={this.props.protectedFetch}
                    selectedbrandID={this.props.selectedbrandID}
                    role={this.userRole}
                    customerId={this.state.customerId}
                    retrieveDevice={() =>
                      this.retrieveCustomerDevices(this.state.customer.id)
                    }
                    userInfo={this.props.userInfo}
                  />
                </div>
                <div label="Logs">
                  <Logs
                    logData={this.state.customer.change_logs || []}
                    customer={this.state.customer}
                  />
                </div>
              </Tabs>
            </div>
          </div>
        </div>
        <Modal
          isOpen={this.state.showEditCustomer}
          onRequestClose={() => this.setState({ showEditCustomer: false })}
          className={"input-modal"}
        >
          <CustomerEdit
            retrieveCustomer={() =>
              this.retrieveCustomer(this.state.customer.id)
            }
            customer={this.state.customer}
            handleCloseModal={() => this.setState({ showEditCustomer: false })}
            protectedFetch={this.props.protectedFetch}
            userInfo={this.props.userInfo}
            storeLocationId={this.state.customer?.store_location_id}
          />
        </Modal>

        <Modal
          isOpen={this.state.showConvertToCommercial}
          onRequestClose={() =>
            this.setState({ showConvertToCommercial: false })
          }
          className={"input-modal"}
        >
          <ConvertCommercialStaff
            handleConvertToCommercialStaff={(obj) => {
              this.handleConvertToCommercialStaff(obj);
              this.setState({ showConvertToCommercial: false });
            }}
            protectedFetch={this.props.protectedFetch}
            handleCloseModal={() =>
              this.setState({ showConvertToCommercial: false })
            }
          />
        </Modal>
      </div>
    );
  }
}
